import React, { Fragment } from "react";
import { Breadcrumbs } from "../../../../AbstractElements";
import { AddProduct, ECommerce, ProductForm } from "../../../../Constants/Constants";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import ProductLeftSidebar from "./ProductLeftSidebar";
import ProductTabContent from "./ProductTabContent/ProductTabContent";

const AddProductContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={AddProduct} parent={ECommerce} />
      <Container fluid>
        <Row>
          <Col xs="12">
            <Card>
              <CommonCardHeader title={ProductForm} headClass="pb-0"/>
              <CardBody>
                <Row className="g-xl-5 g-3 gy-4">
                  <ProductLeftSidebar />
                  <ProductTabContent />
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default AddProductContainer;
